import {observable, computed, action, override, makeObservable} from 'mobx';
import {Screen} from '../../Common/stores/Screen';
import {DesignCollection} from './DesignCollection';
import {packageConsts} from '../../../../constants';

export class DesignScreen extends Screen {
    @observable packagesDataLoaded;

    /* map holding fieldName - packageId pairs */

    fieldPacData;
    /* id of the form package */
    formPackage;
    /* flag that indicates that there're changes in packages */
    packagesChanged;

    constructor(screen, name) {
        super(screen, name);
        makeObservable(this);
        this.collection = new DesignCollection(null);
    }

    setCollection(data) {
        this.collection.insertFields(this, data.fields);
    }

    @override get loading() {
        return this.isLoading || !this.packagesDataLoaded;
    }

    @computed get hasPackagesData() {
        return true;
    }

    setPackagesChanged(value) {
        this.packagesChanged = value;
    }

    initPackagesData(data, formPackData) {
        this.fieldPacData = {};
        if (formPackData) {
            this.formPackage = formPackData.pack;
        }
        for (const item of data) {
            this.fieldPacData[item.name] = item.pack;
        }
        this.setPackagesDataLoaded();
    }

    getPackageId(exec) {
        if (this.packagesDataLoaded) {
            if (this.fieldPacData[exec]) {
                return this.fieldPacData[exec];
            } else if (this.formPackage) {
                return this.formPackage;
            } else {
                return packageConsts.NO_PACKAGE;
            }
        } else {
            return null;
        }
    }

    checkReloadNeeded(screensStore) {
        /* in most cases it won't be needed */
    }

    checkReloadNeededOnRestore(screensStore) {
        /* in most cases it won't be needed */
    }

    @action
    setPackagesDataLoaded() {
        this.packagesDataLoaded = true;
    }

    @override resetSelected() {
        this.setActive(null);
        this.setSelected(null);
        this.collection.setExpanded(false);
    }
}
